import React, { Component } from 'react';
import { CollapsibleCard } from '../../shared/CollapsibleCard';
import { CustomKendoGrid } from '../../shared/CustomKendoGrid';
import { GridColumn, GridColumnMenuFilter } from '@progress/kendo-react-grid';
import { PayrollDataService } from '../../services/PayrollDataService';
import { ViewReportButton } from '../../shared/ViewReportButton';

export class MiscDocuments extends Component {
    constructor(props) {
        super(props);
        this.payrollDataService = new PayrollDataService();
        this.getMiscDocuments = this.getMiscDocuments.bind(this);
        this.handlePrint = this.handlePrint.bind(this);

        this.gridRef = null;
        this.setGridRef = element => {
            this.gridRef = element;
        };
    }

    componentDidUpdate(prevProps) {
        if (!prevProps) return null;
        if (!this.props) return null;
        if (!this.gridRef) return null;
        if (prevProps.district !== this.props.district) {
            this.gridRef.handleDataCallback();
        }
        return null;
    }

    getMiscDocuments() {
        return this.payrollDataService.getMiscDocumentInfo(this.props.district);
    }

    handlePrint(obj) {
        return this.payrollDataService.getMiscDocument(obj.documentId)
            .then(data => data.json());
    }

    render() {
        return (
            <CollapsibleCard title='Resources'>
                <CustomKendoGrid
                    ref={this.setGridRef}
                    refreshData={this.getMiscDocuments}>
                    <GridColumn cell={(props) => (
                        <td>
                            <ViewReportButton getData={() => this.handlePrint(props.dataItem)}></ViewReportButton>
                        </td>
                    )} />
                    <GridColumn title="Month Year" field="yearMonth" columnMenu={GridColumnMenuFilter}></GridColumn>
                    <GridColumn title="Title" field="title" columnMenu={GridColumnMenuFilter}></GridColumn>
                </CustomKendoGrid>
            </CollapsibleCard>
        );
    }
}
